import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Integration from "./components/Thesis";
import SpecialOffer from "./components/SpecialOffer";
import HowItWorks from "./components/HowItWorks";
import Promo from "./components/Promo";
import FinalCta from "./components/FinalCta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Integration />
        <SpecialOffer />
        <HowItWorks />
        <Promo />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}